import { render, staticRenderFns } from "./ProductInquiryContent.vue?vue&type=template&id=241d81ec&scoped=true&"
import script from "./ProductInquiryContent.vue?vue&type=script&lang=ts&"
export * from "./ProductInquiryContent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductInquiryContent.vue?vue&type=style&index=0&id=241d81ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d81ec",
  null
  
)

export default component.exports